import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from './styles.pcss';

const cx = classNames.bind(styles);
const convertTypeToClass = (type) => {
  switch (type) {
    case 'noticeable':
      return type;
    default:
      return null;
  }
};

export class CollapseText extends React.Component {
  state = {
    show: false,
  };

  toggle = () => {
    this.setState({ show: !this.state.show });
  };

  render() {
    const { children, showText /* , hideText */, type, length, textAttrs } = this.props;
    return children.length < length ?
        <span {...textAttrs}>{children}</span>
      : <div className={cx('wrapper', convertTypeToClass(type))}>
          <span {...textAttrs}>
            {this.state.show ?
              children
            : <span>
                {children.slice(0, length)}
                ...{' '}
                <span
                  className={cx('collapseToggle')}
                  onClick={this.toggle}
                  role="button"
                  tabIndex={0}
                >
                  {showText}
                </span>
              </span>
            }
          </span>
          {/*
          <div className={cx('collapse')}>
          <span className={cx('collapseToggle')} onClick={this.toggle} role="button" tabIndex={0}>
            {this.state.show ? hideText : showText}
          </span>
        </div>
        */}
        </div>;
  }
}

CollapseText.propTypes = {
  showText: PropTypes.string,
  hideText: PropTypes.string,
  children: PropTypes.string,
  textAttrs: PropTypes.object,
  type: PropTypes.oneOf(['noticeable']),
  length: PropTypes.number,
};

CollapseText.defaultProps = {
  showText: 'Читать полностью',
  hideText: 'Скрыть',
  textAttrs: {},
  children: '',
};
